export default "__VITE_ASSET__CeEytFq5__"